import React from 'react';
import { Stack, Typography, IconButton } from '@mui/material';
import { ICandidateSourcingSearch, ICandidateSourcingFilters } from './types';
import FilterTagButton from './FilterTagButton';
import { Edit, PostAdd } from '@mui/icons-material';
import { tableSearchButtonStyles } from '../shared/commonStyles';

export default function Filters({
  searchObject,
  isUpdatingFilters,
  onJobDialogOpen,
  onOpenEditModal
}: {
  searchObject: ICandidateSourcingSearch;
  isUpdatingFilters: boolean;
  onJobDialogOpen: () => void;
  onOpenEditModal: () => void;
}) {
  const filters = (searchObject.filters || {}) as ICandidateSourcingFilters;

  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: 'space-between',
        alignItems: 'self-start',
        flexWrap: 'wrap',
        gap: 1
      }}
    >
      <Typography
        variant="body1"
        sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}
      >
        <span>Looking for</span>
        {filters.job_titles && filters.job_titles.length > 0 ? (
          <FilterTagButton
            label={filters.job_titles[0]}
            count={filters.job_titles.length}
            onClick={onOpenEditModal}
            disabled={isUpdatingFilters}
          />
        ) : (
          'candidates'
        )}
        {filters.skills && filters.skills.length > 0 && (
          <>
            <span>skilled in</span>
            {filters.skills.map((skillGroup, groupIndex) => (
              <React.Fragment key={groupIndex}>
                {groupIndex > 0 && <span> AND </span>}
                <FilterTagButton
                  label={skillGroup[0]}
                  count={skillGroup.length}
                  onClick={onOpenEditModal}
                  disabled={isUpdatingFilters}
                />
              </React.Fragment>
            ))}
          </>
        )}
        {filters.industries && filters.industries.length > 0 && (
          <>
            <span> working in </span>
            <FilterTagButton
              label={filters.industries[0]}
              count={filters.industries.length}
              onClick={onOpenEditModal}
              disabled={isUpdatingFilters}
            />
          </>
        )}
        {!!filters.years_of_experience && (
          <>
            <span>with</span>
            <FilterTagButton
              label={`${filters.years_of_experience} years of experience`}
              onClick={onOpenEditModal}
              disabled={isUpdatingFilters}
            />
          </>
        )}
        {filters.location && (
          <>
            <span>located in</span>
            <FilterTagButton
              label={filters.location}
              onClick={onOpenEditModal}
              disabled={isUpdatingFilters}
            />
          </>
        )}
      </Typography>
      <Stack direction="row" spacing={1}>
        <IconButton
          size="small"
          onClick={onOpenEditModal}
          disabled={isUpdatingFilters}
          sx={{ ...tableSearchButtonStyles, height: '35px', padding: '0 5px' }}
        >
          <Edit />
        </IconButton>
        <IconButton
          size="small"
          onClick={onJobDialogOpen}
          sx={{ ...tableSearchButtonStyles, height: '35px', padding: '0 5px' }}
        >
          <PostAdd />
        </IconButton>
      </Stack>
    </Stack>
  );
}
